import { useState } from 'react';
import classes from 'components/StoreLocations/StoreLocationTile/StoreLocationTile.module.scss'
import { Format } from 'utils/Format';
import { ExpandLess, ExpandMore, Room, Phone } from '@material-ui/icons';
import Collapse from '@material-ui/core/Collapse';
import Link from '@material-ui/core/Link';
import Constants from 'config/constants';
import DSGImage from 'assets/svg/dsg.svg';
import GGImage from 'assets/svg/gg.svg';

export default function StoreLocationTile(props) {
	const [storeInfoOpen, setStoreInfoOpen] = useState(!!props.confirmedStore);

	const storeHours = props.store.hours;
	const curbsideHours = props.store.curbsideHours;

	const handleStoreInfo = () => {
		setStoreInfoOpen(!storeInfoOpen);
	};

	const StoreHourItem = (props) => {
		return (
			<div className={classes.StoreHourParent}>
				<div className={classes.StoreHourChild}>
					<p className="body-medium">{props.day}</p>
				</div>
				<div className={classes.StoreHourChild}>
					<p className="body-medium">{Format.splitStoreHours(props.hours)}</p>
				</div>
			</div>
		);
	}

	return (
		<div className={classes.PickupLocationTile}>
			{props.store &&
			<>
				<div className={classes.PickupSelection} onClick={() => props.handleStoreSelection(props.store.location.toString())}>
					{props.showAltChain &&
					<>
						{props.store.chain === Constants.CHAIN_DICKS_SPORTING_GOODS &&
						<div className={classes.ChainContainer}>
							<img src={DSGImage} alt="DICKS SPORTING GOODS"/>
						</div>
						}
						{props.store.chain === Constants.CHAIN_GOLF_GALAXY &&
						<div className={classes.ChainContainer}>
							<img src={GGImage} alt="GOLF GALAXY"/>
						</div>
						}
					</>
					}
					<div className={classes.StoreNameText}>
						<p className="body-large-alt upper bold" style={props.store.chain === Constants.CHAIN_DICKS_SPORTING_GOODS ? {color: "#006554"} : (props.store.chain === Constants.CHAIN_PUBLIC_LANDS ? {color: "#388DAE"} : {color: "#001F39"})}>{props.store.name}</p>
					</div>
					<div>
						<p className="body-medium" style={{color: "#4F4F4F"}}>{Format.capitalizeWords(props.store.street1)}</p>
					</div>
				</div>
				<div>
					<p className={storeInfoOpen ? `dropdown underline ${props.pickupWebsite === Constants.COOKIE_GOLF_GALAXY ? `dropdown-selected-gg` : (props.pickupWebsite === Constants.COOKIE_PUBLIC_LANDS ? `dropdown-selected-pl` : `dropdown-selected-dsg`)}` : `dropdown underline`}>
						<div className={classes.StoreInfoDropdown} onClick={handleStoreInfo}>
							Store Info
							{storeInfoOpen ?
								<ExpandLess fontSize="large"/>
								:
								<ExpandMore fontSize="large"/>
							}
						</div>
					</p>
					<Collapse in={storeInfoOpen} timeout="auto" unmountOnExit>
						<div className={classes.StoreLinks}>
							<div>
								<Link className={classes.StoreLinkMap}
											underline="always"
											target="_blank"
											href={`https://www.google.com/maps?saddr=My+Location&daddr=${props.store.chain},${props.store.street2},${props.store.street1},${props.store.zip}`}>
									<Room className={classes.StoreLinkIcon} fontSize="default"/>
									<p className="body-small bold underline">Get Directions</p>
								</Link>
							</div>
							<div>
								<Link className={classes.StoreLinkPhone}
											underline="always"
											href={`tel:${props.store.phone},0,0`}>
									<Phone className={classes.StoreLinkIcon} fontSize="default"/>
									<p className="body-small bold underline">{props.store.phone}</p>
								</Link>
							</div>
						</div>
						<div className={classes.StoreAddress}>
							<p className="body-medium">{Format.capitalizeWords(props.store.street1)}</p>
							<p className="body-medium">{Format.capitalizeWords(props.store.street2)}</p>
							<p className="body-medium">{Format.capitalizeWords(props.store.city)}, {props.store.state} {props.store.zip}</p>
						</div>
						<div>
							<p className="store-hours bold">Curbside Hours</p>
							<div className={classes.StoreHourItemContainer}>
								<StoreHourItem day="Monday" hours={curbsideHours.mon} />
								<StoreHourItem day="Tuesday" hours={curbsideHours.tue} />
								<StoreHourItem day="Wednesday" hours={curbsideHours.wed} />
								<StoreHourItem day="Thursday" hours={curbsideHours.thu} />
								<StoreHourItem day="Friday" hours={curbsideHours.fri} />
								<StoreHourItem day="Saturday" hours={curbsideHours.sat} />
								<StoreHourItem day="Sunday" hours={curbsideHours.sun} />
							</div>
						</div>
						<div>
							<p className="store-hours bold">Store Hours</p>
							<div className={classes.StoreHourItemContainer}>
								<StoreHourItem day="Monday" hours={storeHours.mon} />
								<StoreHourItem day="Tuesday" hours={storeHours.tue} />
								<StoreHourItem day="Wednesday" hours={storeHours.wed} />
								<StoreHourItem day="Thursday" hours={storeHours.thu} />
								<StoreHourItem day="Friday" hours={storeHours.fri} />
								<StoreHourItem day="Saturday" hours={storeHours.sat} />
								<StoreHourItem day="Sunday" hours={storeHours.sun} />
							</div>
						</div>
					</Collapse>
				</div>
			</>
			}
		</div>
	);
}
